import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    auth: {
      restore_password: {
        new_password: {
          header: 'NEW_HEADER',
          text: 'NEW_TEXT',
          email: 'NEW_EMAIL',
          submit: 'NEW_SUBMIT',
        },
        confirm_email: {
          header: 'CONFIRM_HEADER',
          token: 'CONFIRM_TOKEN',
          text: 'CONFIRM_TEXT',
          submit: 'CONFIRM_SUBMIT',
        },
        change_password: {
          header: 'CHANGE_HEADER',
          password: 'CHANGE_PASSWORD',
          password_confirmation: 'CHANGE_PASSWORD_CONFIRMATION',
          submit: 'CHANGE_SUBMIT',
        },
        save_password: {
          header: 'SAVE_HEADER',
          text: 'SAVE_TEXT',
          log_in: 'SAVE_LOG_IN',
        },
      },
    },
  }));
}
